import "./AboutLandScap.scss";
const AboutLandScap = ({img}) => {
  return (
    <section className="about_landscap p_t">
      <div className="img_wrap">
       
          <img src={img} alt="about" />
       
      </div>
    </section>
  );
};

export default AboutLandScap;
